import {
  Dataset,
  DatasetChunkStream,
  DatasetData,
  DatasetMetadataStream,
  H3Configuration
} from "@/types/dataset";
import {
  createDatasetAttributes,
  createSpatialDatasetFromMetadata
} from "@/utils/dataset";

export const generateDatasetData = (
  data: DatasetChunkStream,
  metadata: DatasetMetadataStream,
  isSpatialAnalysisResult: boolean,
  h3Configuration?: H3Configuration | null
): { datasetData: DatasetData; newDataset: Dataset } => {
  const datasetData: DatasetData = {
    ...metadata,
    rows: data.rows,
    dataset_size_kb: metadata.dataset_size_kb,
    spatial_aggregation_type: metadata.spatial_aggregation_type
  };

  const attributes = createDatasetAttributes(datasetData.columns);
  const newDataset: Dataset = createSpatialDatasetFromMetadata({
    data: metadata,
    attributes,
    isAnalysisResult: isSpatialAnalysisResult,
    h3Configuration
  });

  return {
    datasetData,
    newDataset
  };
};

export const generateRawDatasetDataOnly = (
  data: DatasetChunkStream,
  metadata: DatasetMetadataStream
): { datasetData: DatasetData; newDataset: undefined } => ({
  datasetData: {
    ...metadata,
    rows: data.rows,
    dataset_size_kb: metadata.dataset_size_kb,
    spatial_aggregation_type: metadata.spatial_aggregation_type
  },
  newDataset: undefined
});
